import React from 'react';
import {Trans} from 'react-i18next';
import InfoDialog from '../../../../components/dialogs/InfoDialog';

export default function PreviewHint() {
  return (
    <InfoDialog
      popoverMaxWidth={'350px'}
      trigger={'click'}
      placement={'right'}
      title={
        <Trans i18nKey="tutorials.steps.addskulooktour.preview.title">
          Preview
        </Trans>
      }
      description={
        <Trans i18nKey="p.p.addoreditproduct.product.preview.hint.desc">
          Preview will present the appearance of the Product list on the module
          side, mainly displaying the info of the Product list.
          <br />
          Note: Currently, selecting SKU will not directly apply the effect to
          the model, If you want to see the effect of SKU, you need to go to the
          SKU list.
        </Trans>
      }
    >
      <label className="cursor-help">
        <Trans i18nKey="tutorials.steps.addskulooktour.preview.title">
          Preview
        </Trans>{' '}
        <i className="fa fa-question-circle" />
      </label>
    </InfoDialog>
  );
}
